var _path, _path2, _path3, _path4, _path5, _path6, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplyToAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H15",
    stroke: "#282828",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5C20.25 4.86193 20.1381 4.75 20 4.75C19.8619 4.75 19.75 4.86193 19.75 5H20.25ZM20 19L21.4434 16.5H18.5566L20 19ZM19.75 5V16.75H20.25V5H19.75Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H15",
    stroke: "#282828",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H15",
    stroke: "#282828",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H15",
    stroke: "#282828",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H10",
    stroke: "#282828",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 14,
    height: 19,
    rx: 2.5,
    stroke: "#282828"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyToAll);
export default __webpack_public_path__ + "static/media/apply-to-all.8615615f443bce57c51c6b501e1a14a7.svg";
export { ForwardRef as ReactComponent };